import React,{Component} from 'react'
import './Lesson.css'
import {Table} from 'react-bootstrap'
import {LessonModal} from './LessonModal'
import {OnAdd, OnCRUD} from '../Shared/ActionControl'
import {ToDate,ToClick} from '../Shared/ViewControl'

export class Lessons extends Component{

    constructor (props){
        super(props)
        this.state = {items:[], itemId:0, show:false, mode:0, loading:false}
        this.entity='Lesson'
    }

    componentDidMount(){
        this.Load()
    }

    Load() {
        this.setState({loading:true})
        this.props.global.GET(this.entity)
        .then(data => this.setState({items:data, loading:false}))
        .catch(error => console.log({ error }))
    }

    Delete(id) {
        this.props.global.DELETE(this.entity, id)
        .then(()=> this.Load())
    }

    componentWillUnmount() {
        this.setState({items:null})        
    }

    render() {

        const {items}=this.state

        let filteredItems = items.filter(
            (item)=>{
                return (item.Title+item.Content).indexOf(this.props.search)!==-1;
            }   
        )

        let modalClose =() => {
            this.setState({show:false})
            this.componentDidMount()
        }

        return (
            <div className="FullScreen">

<Table striped hover bordered size="sm">
<thead>
    <tr>
        <th>رقم</th>
        <th>الدرس</th>
        <th>المعلمة</th>
        <th>ملاحظات</th>        
        <th>تاريخ</th>
        <OnAdd onClick={()=>this.setState({show:true, itemId:0, mode:2})}/>
    </tr>
</thead>

<tbody>
    {
        filteredItems.map(item=>
            <tr key={item.Id}>

            <td>{item.Id}</td>
            <ToClick value={item.Id} text={item.Title} onClick={()=> this.setState({show:true, itemId:item.Id, mode:0})} />
            <td>{item.Master}</td>
            <td>{item.Content}</td>
            <ToDate value={item.updatedAt} />
            <OnCRUD 
                onInfo={()=> this.setState({show:true, itemId:item.Id, mode:0})} 
                onEdit={()=> this.setState({show:true, itemId:item.Id, mode:1})} 
                onDel={()=> this.Delete(item.Id)} 
            />
            </tr>
        )
    }
</tbody>
</Table>

{this.state.show ?
    <LessonModal 
        global={this.props.global}
        entity={this.entity}
        id={this.state.itemId}
        mode={this.state.mode}
        show={this.state.show}
        onHide={modalClose}
    />
: null}

</div>
        )
    }
}